import classNames from "classnames";
import React, { FunctionComponent } from "react";
import { DetailedCartItem } from "../../../../../../../../../context/CartContext/CartContext.api.types";
import { displayMoney } from "../../../../../../../../../utils/displayMoney";
import { displayWeight } from "../../../../../../../../../utils/displayWeight";

import "./MainDetail.scss";

type Props = {
  cartDetailedItem: DetailedCartItem;
  labels: LenghtLabel;
};

const displayColor = (color: string) => {
  switch (color) {
    // to do, cambiarlos, los colores deberian ser en ingles y todo en mayus
    case "amarillo":
      return "OA";
      break;
    case "rojo":
      return "OR";
      break;
    case "blanco":
      return "OB";
      break;
    default:
      break;
  }
};

const MainDetail: FunctionComponent<Props> = ({ cartDetailedItem, labels }) => {
  // TO DO - add this constants to a new CartItemContext
  const isVariationMaterialSilver =
    cartDetailedItem.product.material === "silver";
  const isVariationMaterialColorRed =
    cartDetailedItem.variation.color === "rojo";
  const isVariationMaterialColorGold =
    cartDetailedItem.variation.color === "amarillo";
  const isVariationMaterialColorWhite =
    cartDetailedItem.variation.color === "blanco";

  return (
    <main
      className={classNames("main-detail", {
        "main-detail--silver": isVariationMaterialSilver,
      })}
    >
      {!isVariationMaterialSilver ? (
        <span className="main-detail__header">Color</span>
      ) : null}
      <span className="main-detail__header">{labels.cartGaugeLabel}</span>
      <span className="main-detail__header">{labels.cartLenghtLabel}</span>
      <span className="main-detail__header">Peso</span>
      <span className="main-detail__header">Hechura</span>
      {!isVariationMaterialSilver ? (
        <div className={"main-detail__color"}>
          <span
            className={classNames("main-detail__color__icon", {
              "main-detail__color__icon--gold": isVariationMaterialColorGold,
              "main-detail__color__icon--red": isVariationMaterialColorRed,
              "main-detail__color__icon--white": isVariationMaterialColorWhite,
            })}
          />
          <span>{displayColor(cartDetailedItem.variation.color)}</span>
        </div>
      ) : null}
      <span className="main-detail__description">
        {cartDetailedItem.variation.gauge}
      </span>
      <span className="main-detail__description">
        {cartDetailedItem.variation.length} {labels.unit}
      </span>
      <span className="main-detail__description">
        {displayWeight(cartDetailedItem.variation.weight.replace(",", "."))}
      </span>
      <span className="main-detail__description">
        {cartDetailedItem.manufacturingCost == 0
          ? "Consultar"
          : displayMoney(cartDetailedItem.manufacturingCost)}
      </span>
    </main>
  );
};

export default MainDetail;
